import { useEffect } from 'react';
import { registerWebMcpTools } from '../lib/webmcp';

/**
 * Registers WebMCP tools on page load so agent scanners can detect them.
 * No UI — side-effect only.
 */
export function WebMcpProvider() {
  useEffect(() => {
    let cleanup: (() => void) | undefined;
    let cancelled = false;

    void registerWebMcpTools().then((fn) => {
      if (cancelled) {
        fn();
        return;
      }
      cleanup = fn;
    });

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);

  return null;
}
